import { gql } from '__generated__';

export default gql(`
  mutation ToggleAutoAssignTicketNumbers($input: ToggleEventSettingInput!) {
    toggleAutoAssignTicketNumbers(input: $input) {
      id
      auto_assign_ticket_numbers
    }
  }
`);
